import { SITE_SCANNER_APP_ID } from '../consts/dom-consts';
import { AzureTicketCreatorConfig } from '../modules/azure-ticket-creator';

import { logger } from './Logger';

/**
 * Site Scanner's config for the (otherwise host-agnostic) azure-ticket-creator module.
 * This is the one place that reads the Vite env and adapts the app's logger onto the module's
 * contract. Defined at module scope so the object is referentially stable and the provider
 * resolves it once.
 */
export const azureTicketCreatorConfig: AzureTicketCreatorConfig = {
	clientId: import.meta.env.VITE_AZURE_APP_CLIENT_ID as string,
	redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URL as string,
	// Base URLs are optional — the module falls back to its Azure DevOps defaults when unset.
	apiBaseUrl: import.meta.env.VITE_AZURE_API_URL as string,
	usersBaseUrl: import.meta.env.VITE_AZURE_USERS_API_URL as string,
	logger,
	appElement: SITE_SCANNER_APP_ID
};
